module.exports = __webpack_public_path__ + "img/yi.61e5e618.png";